import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { paperworkConst } from "../../utilities/constant";
import { appAction } from "../../actions/app.action";
import SectionHeader from "../../components/UI/SectionHeader";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const styles = (theme) => ({
  caption: {
    fontSize: "20px",
    lineHeight: 1.4,
    marginBottom: "10px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
  },
  link: {
    color: `${theme.palette.primary.main} !important`,
    padding: ".5%",
    "& a": {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
      transition: ".2s",
    },
    "& a:hover": {
      color: `${theme.palette.primary.dark} !important`,
    },
  },
});

class Paperwork extends React.Component {
  componentDidMount() {
    this.props.dispatch(appAction.toggleMainNav(true));
    this.props.dispatch(appAction.setPortfolioNav(false));
    window.scrollTo(0, 0);
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <SectionHeader text={paperworkConst.title} />
        {paperworkConst.contents.map((content, i) => (
          <p key={i} className={classes.caption}>
            {content}
          </p>
        ))}
        <ul>
          {paperworkConst.links.map((link, i) => (
            <li key={i} className={classes.link}>
              <a target="_blank" href={link.url}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
}

Paperwork.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(Paperwork));



// WEBPACK FOOTER //
// ./src/containers/Paperwork/index.jsx